import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2, FileText, ArrowUpRight } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { ESSAP_CATS } from "@/lib/essap";

const PostCard = ({ p }) => (
  <Link to={`/essap/publication/${p.id}`} data-testid={`essap-post-card-${p.id}`} className="group flex gap-4 rounded-2xl border border-emerald-900/10 bg-white p-4 sm:p-5 hover:shadow-lg hover:-translate-y-0.5 transition-[box-shadow,transform]">
    {p.image && <img src={fileUrl(p.image)} alt="" className="h-20 w-28 rounded-lg object-cover shrink-0 hidden sm:block" />}
    <div className="flex-1 min-w-0 space-y-1.5">
      <div className="text-xs uppercase tracking-[0.14em] text-emerald-700 font-semibold">{fmtDate(p.created_at)}</div>
      <h3 className="font-display text-lg font-bold text-slate-900 leading-snug">{p.titre}</h3>
      {p.contenu && <p className="text-sm text-slate-600 line-clamp-2">{p.contenu}</p>}
      <div className="flex items-center gap-3 pt-1 text-sm">
        {p.fichier && <span className="inline-flex items-center gap-1 text-rose-700"><FileText className="h-4 w-4" /> PDF joint</span>}
        <span className="inline-flex items-center gap-1 font-semibold text-emerald-800">Lire <ArrowUpRight className="h-4 w-4" /></span>
      </div>
    </div>
  </Link>
);

export default function EssapCategory() {
  const { categorie } = useParams();
  const cat = ESSAP_CATS.find((c) => c.key === categorie);
  const [items, setItems] = useState(null);

  useEffect(() => {
    setItems(null);
    api.get("/essap/posts", { params: { categorie } }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [categorie]);

  if (!cat) return <p className="max-w-5xl mx-auto px-4 py-14 text-slate-500">Rubrique introuvable.</p>;

  return (
    <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
      <h2 data-testid="essap-category-title" className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">{cat.label}</h2>
      <p className="mt-2 text-slate-600">{cat.desc}</p>
      {items === null ? <Loader2 className="mt-10 h-8 w-8 animate-spin text-emerald-700" /> : items.length ? (
        <div data-testid="essap-posts-list" className="mt-8 space-y-4">{items.map((p) => <PostCard key={p.id} p={p} />)}</div>
      ) : <p data-testid="essap-posts-empty" className="mt-8 text-slate-500">Aucune publication pour le moment.</p>}
    </section>
  );
}
